'use strict';

class Slide {
	constructor(el) {
		this.$slide = $(el);
		this.$slideContainer = this.$slide.find('.js_slide_container');
		this.$pagination = this.$slide.find('.js_slide_dot');
		this.swiper = null;
		this.init();
	}

	init() {
		// if (window.innerWidth <= 1023) {
			this.build();
		// }
	}

	build() {
		// if (!this.swiper) {
			this.swiper = new Swiper(this.$slideContainer, {
				// parallax: true,
				fade: false,
				spaceBetween: 30,
				slidesPerView: 'auto',
				centeredSlides: true,
				autoHeight: true,
				simulateTouch: true,
				speed: 1000,
				navigation: {
					nextEl: this.$slide.find('.swiper-button-next')[0],
					prevEl: this.$slide.find('.swiper-button-prev')[0]
				},
				pagination: {
					el: this.$pagination[0],
					type: 'bullets',
					clickable: true,
				},
				watchOverflow: true,
			});
			this.swiper.init();
		// }
	}

	destroy() {
		if (this.swiper) {
			this.swiper.destroy(true, true);
			this.swiper = null;
		}
	}

	update() {
		this.build();
		// if (window.innerWidth <= 1023) {
		// 	this.build();
		// } else {
		// 	this.destroy();
		// }
	}
}

export default Slide;
